<template>
  <div class="signup-container">
    <section class="signup-section">
      <div class="container">
        <h2 class="text-center">Create Account</h2>
        <p class="text-center">
          We just need a few details to create your account and get you on your way.
        </p>
        <form @submit.prevent="signUp">
          <!-- Organisation -->
          <div class="form-group">
            <label for="organisation">Organization</label>
            <input
              type="text"
              v-model="organisation"
              id="organisation"
              class="form-control"
              placeholder="Jane_Doe"
              required
            />
          </div>

          <!-- Email -->
          <div class="form-group">
            <label for="email">Official Email Address</label>
            <input
              type="email"
              v-model="email"
              id="email"
              class="form-control"
              placeholder="jane.doe@gmail.com"
              required
            />
          </div>

          <!-- Password -->
          <div class="form-group">
            <label for="password">Password</label>
            <div class="password-container">
              <input
                :type="passwordVisible ? 'text' : 'password'"
                v-model="password"
                id="password"
                class="form-control"
                placeholder="Password"
                required
              />
              <button
                type="button"
                class="toggle-password"
                @click="togglePasswordVisibility"
              >
                <i :class="passwordVisible ? 'icon-eye-off' : 'icon-eye'"></i>
              </button>
            </div>

          </div>

          <!-- Admin Code (optional, hidden) -->
          <div class="form-group">
            <label for="adminCode" class="text-muted" style="font-size:0.85rem;">
              Admin Code <span class="text-muted">(optional)</span>
            </label>
            <input
              type="password"
              v-model="adminCode"
              id="adminCode"
              class="form-control"
              placeholder="Enter admin registration code if applicable"
            />
          </div>

          <!-- Submit Button -->
          <div class="text-center">
            <button type="submit" class="submit-btn">Proceed</button>
          </div>
        </form>

        <!-- Switch to Sign In -->
        <p class="text-center">
          Already have an account?
          <button @click="switchToLogin" class="link-button">Sign In</button>
        </p>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  name: 'SignUpComponent',
  data() {
    return {
      organisation: '',
      email: '',
      password: '',
      adminCode: '',
      passwordVisible: false,
    };
  },
  methods: {
    ...mapActions('configurerAuth', { createUser: 'signUp' }),
    switchToLogin() {
      this.$emit('switch-view', 'login'); // Notify parent to switch view
    },
    async signUp() {
      if (!this.email.includes('@')) {
        this.$swal({
          icon: 'error',
          title: 'Invalid Email',
          text: 'Please enter a valid email address.',
        });
        return;
      }

      try {
        await this.createUser({
          organization: this.organisation,
          email: this.email,
          password: this.password,
          adminCode: this.adminCode,
        });

        this.$swal({
          icon: 'success',
          title: 'Account Created',
          text: 'Taking you to your dashboard setup.',
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          this.$emit('signup-success');
        });
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Registration Failed',
          text: 'Please check your details and try again.',
        });
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible;
    },
  },
};
</script>

<style scoped>
.signup-section {
  font-family: "Work Sans", sans-serif;
  padding: 40px;
  /* Glassmorphism */
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.3);

  border-radius: 24px;
  max-width: 420px;
  margin: 20px auto;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.1);
}

.text-center {
  text-align: center;
  margin-bottom: 24px;
}

h2 {
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}

p {
  color: #6c757d;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.9rem;
}

.form-control {
  width: 100%;
  height: 48px;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.form-control:focus {
  background: #ffffff;
  border-color: #007D53;
  box-shadow: 0 0 0 3px rgba(0, 125, 83, 0.1);
  outline: none;
}

.password-container {
  display: flex;
  align-items: center;
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6c757d;
}

.submit-btn {
  width: 100%;
  height: 48px;
  background: #007D53;
  color: #ffffff;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 125, 83, 0.2);
}

.submit-btn:hover {
  background: #006644;
  transform: translateY(-1px);
  box-shadow: 0 6px 12px rgba(0, 125, 83, 0.3);
}

.link-button {
  background: none;
  border: none;
  color: #007D53;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
  font-size: 14px;
  margin-left: 5px;
}

.link-button:hover {
  text-decoration: underline;
}
</style>
